import { withTranslation } from "react-i18next";

const TableComponent = ({
  t,
  transactions,
  headerOfTable,
  bodyOfTable,
  rowHandler,
}) => {
  function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  return (
    <div className="px-4 sm:px-0">
      <div className="mt-8 -mx-4 bg-gray-700 rounded-md shadow-md sm:-mx-0">
        <table className="min-w-full divide-y divide-gray-300">
          <thead className="">
            <tr>
              {headerOfTable.length > 0 &&
                headerOfTable.map((headerName, index) => (
                  <th
                    key={headerName.name}
                    scope="col"
                    className={`${
                      index === 0
                        ? "py-2 pl-4 pr-3 text-sm font-semibold text-left text-white sm:pl-2"
                        : index === headerOfTable.length - 2
                        ? "px-3 py-2 text-sm font-semibold text-left text-white"
                        : index === headerOfTable.length - 1
                        ? "relative py-2 pl-3 pr-4 sm:pr-2"
                        : "hidden px-3 py-2 text-sm font-semibold text-left text-white xl:table-cell"
                    }`}
                  >
                    {index === headerOfTable.length - 1 ? (
                      <span className="sr-only">Edit</span>
                    ) : (
                      t(`${headerName?.name}`)
                    )}
                  </th>
                ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {transactions.length > 0 && transactions.map((transaction) => (
              <tr
                className={`${
                  transaction.selected ? "bg-amber-200" : "hover:bg-amber-100"
                } `}
                key={transaction.id}
                onClick={() => rowHandler(transaction.id)}
              >
                {bodyOfTable.length > 0 &&
                  bodyOfTable.map((bodyName, index) =>
                    index === 0 ? (
                      <td
                        key={bodyName}
                        className="w-full py-1 pl-4 pr-3 text-sm text-gray-900 max-w-0 xl:w-auto xl:max-w-none sm:pl-2"
                      >
                        {transaction[bodyName]}
                        <dl className="py-2 m-0 font-normal xl:hidden">
                          {bodyOfTable.length > 0 &&
                            bodyOfTable.map(
                              (bn, index) =>
                                index !== 0 &&
                                index !== bodyOfTable.length - 2 &&
                                index !== bodyOfTable.length - 1 && (
                                  <div className="space-y-1" key={bn}>
                                    <dt className="">
                                      {capitalizeFirstLetter(bn)}
                                    </dt>
                                    <dd className="text-gray-700 truncate">
                                      {transaction[bn]}
                                    </dd>
                                  </div>
                                )
                            )}
                        </dl>
                      </td>
                    ) : index === bodyOfTable.length - 2 ? (
                      <td
                        key={bodyName}
                        className="px-3 py-1 text-sm font-medium text-gray-500"
                      >
                        {transaction[bodyName]}
                      </td>
                    ) : index === bodyOfTable.length - 1 ? (
                      <td
                        key={bodyName}
                        className="py-1 pl-3 pr-4 text-sm font-medium text-right sm:pr-2"
                      >
                        {transaction[bodyName]}
                      </td>
                    ) : (
                      <td
                        key={bodyName}
                        className="hidden px-3 py-1 text-sm font-medium text-gray-500 xl:table-cell"
                      >
                        {transaction[bodyName]}
                      </td>
                    )
                  )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>

  );
};

export default withTranslation()(TableComponent);
